import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  return {
    root: {
      '& .MuiPaper-root': {
        backgroundColor: '#FFFFFF',
        width: '40%',
        maxWidth: 480,
        borderRadius: 20,
        padding: '12px 24px 24px 6px',
      },
      '& h3': {
        fontWeight: 700
      }
    },
    text:{
      fontWeight: 400
    },
    actionButtons: {
      gap: 8,
    }
  };
});
